import React, { useMemo } from "react";

import { Outlet, useNavigate } from "react-router-dom";

import DashboardSidebar from "../../../shared/layout/DashboardSidebar";

import DashboardScrollArea from "../../../shared/layout/DashboardScrollArea";

import ImpersonationBanner from "../../../shared/components/ImpersonationBanner";

import useEndImpersonation from "../../../shared/hooks/useEndImpersonation";

import { useTranslation } from "../../../i18n";

import {

  IconDashboard,

  IconUsers,

  IconDeletionCases,

  IconEmailAlerts,

  IconSettings,

  IconDocumentation,

  IconSupport,

  IconOffer,

} from "../../../shared/icons/dashboardNavIcons";



const BASE = "/dashboard/admin";



const AdminDashboardLayout = () => {

  const navigate = useNavigate();

  const { t } = useTranslation();

  const { endImpersonation, ending } = useEndImpersonation();



  const navItems = useMemo(

    () => [

      {

        label: t("nav.dashboard"),

        to: BASE,

        icon: <IconDashboard />,

        end: true,

      },

      { label: t("nav.users"), to: `${BASE}/users`, icon: <IconUsers /> },

      {

        label: t("nav.deletionCases"),

        to: `${BASE}/deletion-cases`,

        icon: <IconDeletionCases />,

      },

      {

        label: t("nav.emailAlerts"),

        to: `${BASE}/email-alerts`,

        icon: <IconEmailAlerts />,

      },

      {
        label: t("adminSupport.navTitle"),
        to: `${BASE}/support-tickets`,
        icon: <IconSupport />,
      },

      {
        label: t("adminOffers.navTitle"),
        to: `${BASE}/custom-offers`,
        icon: <IconOffer />,
      },

      { label: t("nav.settings"), to: `${BASE}/settings`, icon: <IconSettings /> },

    ],

    [t]

  );



  const footerItems = useMemo(

    () => [

      {

        label: t("nav.documentation"),

        to: `${BASE}/documentation`,

        icon: <IconDocumentation />,

      },

    ],

    [t]

  );



  return (

    <div className="min-h-screen bg-[#f4f6f7]">

      <DashboardSidebar

        navItems={navItems}

        footerItems={footerItems}

        brandTitle={t("common.globalReputation")}

        brandSubtitle={t("common.brandSubtitle")}

        primaryAction={{

          label: t("nav.adminDeletionCases"),

          onClick: () => navigate(`${BASE}/deletion-cases`),

        }}

      />

      <main className="ml-[264px] flex h-screen min-h-0 min-w-0 flex-col overflow-hidden">

        <ImpersonationBanner

          onEndImpersonation={endImpersonation}

          ending={ending}

        />

        <DashboardScrollArea>

          <Outlet />

        </DashboardScrollArea>

      </main>

    </div>

  );

};



export default AdminDashboardLayout;


